import { Box } from "@mui/material";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { red } from "@mui/material/colors";

const RuleBreaks = ({ ruleBreaks }: { ruleBreaks: string[] | undefined }) => {
  return ruleBreaks && ruleBreaks?.length > 0 ? (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.background.paper,
        borderRadius: "8px",
        border: (theme) => `1px solid ${theme.palette.divider}`,
        marginTop: 2,
      }}
    >
      <Box
        sx={{
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          padding: (theme) => theme.spacing(1),
          paddingLeft: (theme) => theme.spacing(2),
          height: "auto",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <strong>Rule Breaks</strong>
        <ReportProblemIcon sx={{ color: red[800] }} />
      </Box>
      <Box sx={{ p: 2 }}>
        <ul
          style={{
            paddingLeft: "20px",
            margin: 0,
            listStyleType: "disc",
            display: "flex",
            flexDirection: "column",
            gap: "5px",
          }}
        >
          {ruleBreaks.map((rule) => (
            <li
              key={`rule-break-${rule.substring(0, 10)}`}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {rule}
            </li>
          ))}
        </ul>
      </Box>
    </Box>
  ) : null;
};

export default RuleBreaks;
